module.exports = __webpack_public_path__ + "img/4.520548e2.png";